export default __webpack_public_path__ + "static/media/stock-market-circle.683db6aa.webp";